module.exports = __webpack_public_path__ + "static/media/Header_elBgimage_665570.04fb9a10.jpg";